module.exports = __webpack_public_path__ + "static/media/hero-vector.3faf2611.svg";